module.exports = __webpack_public_path__ + "newsletter-e894f0172eded38e77cc.png";